import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Send = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="send icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12L4.18085 1.1854C2.9493 0.513392 1.56931 1.78849 2.12777 3.08243L5.33593 10.5156L16.1414 12L5.33593 13.4844L2.12777 20.9176C1.56931 22.2115 2.94931 23.4866 4.18085 22.8146L24 12Z"
    />
  </svg>
)
